import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  type GlobalSearchResultTypeEnum,
  GlobalSearchResultTypes,
} from '../../../../../../value-objects/enums'

export const useFormatGlobalSearchResultTypeLabel = () => {
  const intl = useProcurifyIntl()

  return (type: GlobalSearchResultTypeEnum) => {
    switch (type) {
      case GlobalSearchResultTypes.ORDER_REQUEST:
        return intl.formatMessage(messages.orderRequestLabel)
      case GlobalSearchResultTypes.EXPENSE_REQUEST:
        return intl.formatMessage(messages.expenseRequestLabel)
      case GlobalSearchResultTypes.TRAVEL_REQUEST:
        return intl.formatMessage(messages.travelRequestLabel)
      case GlobalSearchResultTypes.PURCHASE_ORDER:
        return intl.formatMessage(messages.purchaseOrderLabel)
      case GlobalSearchResultTypes.BILL:
        return intl.formatMessage(messages.billLabel)
      case GlobalSearchResultTypes.PAYMENT:
        return intl.formatMessage(messages.paymentLabel)
      case GlobalSearchResultTypes.CONTRACT:
      // Contract titles render `subject.label` directly, so the entity type
      // prefix never applies. Return '' to match catalog-item and vendor.
      case GlobalSearchResultTypes.CATALOG_ITEM:
      case GlobalSearchResultTypes.VENDOR:
      default:
        return ''
    }
  }
}
